export const SENIORITY = "SENIORITY";
export const FASTEST = "FASTEST";
export const PRIMARYJOB = "PRIMARYJOB";
export const JOB = "JOB ROLES";
export const SKILLS = "SKILLS";
export const WORKCENTER = "WORKCENTER";
export const LOCATION = "LOCATION";
export const WCFIFO = "WCFIFO";
export const FULL_TIME_WORKER = "FullTime";
export const PART_TIME_WORKER = "PartTime";
export const FLEX_WORKER = "FlexWorker";
export const SHIFT_DETAILS = "Shift Details";
export const ASSIGN_SHIFT = "Assign Shift";
export const SET_PREFERRED_WORKERS = "Forced Overtime Preference";
export const ERROR = "Error";
export const WARNING = "Warning";
export const SUCCESS = "Success";

// Worker Activity Reports
export const WORKERS_WITH_ATLEAST_1_SHIFT = "WORKERS WITH AT LEAST 1 SHIFT";
export const WORKERS_WITH_NO_SHIFTS = "WORKERS WITH NO SHIFTS";
export const HOURS_COMPLETED = "HOURS COMPLETED";
export const NO_CALL_NO_SHOWS = "NO CALL NO SHOWS";
export const WORKER_CANCELLATIONS = "WORKER CANCELLATIONS";
export const ALL = "ALL";

export const FILTER_JOB = "job";
export const FILTER_JOB_KEY = "jobs";
export const FILTER_PRIMARY_JOB_KEY = "primaryJobs";
export const FILTER_SKILL = "skill";
export const FILTER_SKILL_KEY = "skills";
export const FILTER_SHIFT_STATUS_KEY = "shiftStatuses";
export const FILTER_SHIFT_BY_KEY = "shiftTypes";
export const FILTER_OVERTIME_AVAILABILITY_KEY = "shiftPatternsWithDates";
export const FILTER_SKILL_PRIORITIES = "skillPriorities";
export const FILTER_SKILL_PRIORITIES_KEY = "skillPriorities";
export const FILTER_CERTIFICATIONS_KEY = "certifications";
export const FILTER_JOB_SKILL = "jobSkill";
export const FILTER_JOB_SKILL_KEY = "jobSkills";
export const FILTER_ORPHAN_SKILL = "orphanSkill";
export const FILTER_ORPHAN_SKILL_KEY = "orphanSkills";
export const FILTER_LOCATION = "location";
export const FILTER_LOCATION_KEY = "locations";
export const FILTER_SHIFT_LOCATION_KEY = "shiftLocations";
export const FILTER_SHIFT_PATTERN = "shiftPattern";
export const FILTER_SHIFT_PATTERN_KEY = "shiftPatterns";
export const FILTER_TIME_OFF_TYPES_KEY = "timeOffTypes";
export const FILTER_MANAGER = "manager";
export const FILTER_MANAGER_KEY = "managers";
export const FILTER_PUBLISHED_BY_KEY = "publishedBy";
export const FILTER_WORKER_SUB_TYPE = "workerSubType";
export const FILTER_WORKER_SUB_TYPE_KEY = "workerSubTypes";
export const FILTER_WORKER_TYPE = "workerType";
export const FILTER_WORKER_TYPE_KEY = "workerTypes";
export const FILTER_ATTENDANCE_STATUS = "attendanceStatus";
export const FILTER_ATTENDANCE_STATUS_KEY = "attendanceStatuses";
export const FILTER_WORK_CENTERS_KEY = "workCenters";
export const FILTER_SHIFT_PATTERNS_WITH_DATES_KEY = "shiftpatternswithdates";
export const FILTER_WORKER_STATUS_KEY = "workerStatuses";
export const FILTER_RELATIONSHIPS = "filterRelationships";
export const FILTER_WORK_CENTERS = "workCenters";
export const FILTER_SHIFT_WORK_CENTERS_KEY = "shiftWorkCenters";
export const FILTER_SHIFT_PATTERNS_WITH_DATES = "shiftpatternswithdates";
export const FILTER_WORKER_STATUS = "workerStatus";
export const FILTER_WORK_CENTER_SHIFT_PATTERN = "shiftPatternWorkCenter";
export const FILTER_LEAVE_TYPE = "leaveType";
export const FILTER_LEAVE_TYPE_KEY = "leaveTypes";
export const FILTER_SCHEDULING_STATUS = "schedulingStatus";

export const DUMMY_PRIORITIES_ARRAY = [
  {
    id: 0,
    code: "A",
    name: "Default",
    description: "Default Priority",
    multiplier: 1,
    hexColor: "",
    isDefault: true,
  },
];

export const ALL_FILTERS = [
  FILTER_JOB,
  FILTER_SKILL,
  FILTER_JOB_SKILL,
  FILTER_ORPHAN_SKILL,
  FILTER_LOCATION,
  FILTER_SHIFT_PATTERN,
  FILTER_WORK_CENTER_SHIFT_PATTERN,
  FILTER_MANAGER,
  FILTER_WORKER_SUB_TYPE,
  FILTER_WORKER_TYPE,
  FILTER_ATTENDANCE_STATUS,
  FILTER_RELATIONSHIPS,
];

export const SCHEDULER_FILTERS = [
  FILTER_JOB,
  FILTER_SKILL,
  FILTER_JOB_SKILL,
  FILTER_LOCATION,
  FILTER_WORK_CENTERS,
  FILTER_MANAGER,
  FILTER_SHIFT_PATTERNS_WITH_DATES,
  FILTER_WORK_CENTER_SHIFT_PATTERN,
  FILTER_RELATIONSHIPS,
  FILTER_WORKER_TYPE,
];

export const WORKER_TABLE_FILTERS = [
  FILTER_JOB,
  FILTER_LOCATION,
  FILTER_WORK_CENTERS,
  FILTER_SHIFT_PATTERN,
  FILTER_WORK_CENTER_SHIFT_PATTERN,
  FILTER_MANAGER,
  FILTER_WORKER_TYPE,
  FILTER_WORKER_SUB_TYPE,
  FILTER_WORKER_STATUS,
  FILTER_RELATIONSHIPS
];

export const USERS_TABLE_FILTERS = [
  FILTER_WORK_CENTERS,
  FILTER_LOCATION,
  FILTER_RELATIONSHIPS
];

export const ATTENDANCE_REPORT_FILTERS = [
  FILTER_LOCATION,
  FILTER_WORK_CENTERS,
  FILTER_MANAGER,
  FILTER_WORKER_TYPE,
  FILTER_WORKER_SUB_TYPE,
  FILTER_ATTENDANCE_STATUS,
  FILTER_RELATIONSHIPS
];

export const WORKER_ACTIVITY_FILTERS = [
  FILTER_LOCATION,
  FILTER_WORK_CENTERS,
  FILTER_MANAGER,
  FILTER_WORKER_TYPE,
  FILTER_ATTENDANCE_STATUS,
  FILTER_WORKER_SUB_TYPE,
  FILTER_RELATIONSHIPS
];

export const JOBS_MATRIX_FILTERS = [
  FILTER_JOB,
  FILTER_LOCATION,
  FILTER_WORK_CENTERS,
  FILTER_SHIFT_PATTERN,
  FILTER_WORK_CENTER_SHIFT_PATTERN,
  FILTER_MANAGER,
  FILTER_WORKER_TYPE,
  FILTER_WORKER_SUB_TYPE,
  FILTER_RELATIONSHIPS,
];

export const TIME_OFF_BALANCES_FILTERS = [
  FILTER_LOCATION,
  FILTER_WORK_CENTERS,
  FILTER_SHIFT_PATTERN,
  FILTER_WORK_CENTER_SHIFT_PATTERN,
  FILTER_LEAVE_TYPE,
  FILTER_MANAGER,
  FILTER_RELATIONSHIPS,
];

export const FULL_TIME_SHIFTS_FILTERS = [
  FILTER_LOCATION,
  FILTER_WORK_CENTERS,
  FILTER_SHIFT_PATTERN,
  FILTER_WORK_CENTER_SHIFT_PATTERN,
  FILTER_JOB,
  FILTER_SCHEDULING_STATUS,
  FILTER_WORKER_TYPE,
  FILTER_WORKER_SUB_TYPE,
  FILTER_RELATIONSHIPS,
];

export const FULL_TIME_WORKER_FILTERS = [
  FILTER_JOB,
  FILTER_SKILL,
  FILTER_JOB_SKILL,
  FILTER_LOCATION,
  FILTER_WORK_CENTERS,
  FILTER_MANAGER,
  FILTER_WORKER_TYPE,
  FILTER_WORKER_SUB_TYPE,
  FILTER_SHIFT_PATTERNS_WITH_DATES,
  FILTER_WORK_CENTER_SHIFT_PATTERN,
  FILTER_SCHEDULING_STATUS,
  FILTER_WORKER_STATUS,
  FILTER_RELATIONSHIPS,
];

export const SKILL_EVALUATION_FILTERS = [
  FILTER_LOCATION,
  FILTER_WORK_CENTERS,
  FILTER_MANAGER,
  FILTER_WORKER_TYPE,
  FILTER_WORKER_SUB_TYPE,
  FILTER_RELATIONSHIPS,
  FILTER_SKILL,
];

export const EVALUATIONS_FILTERS = [
  FILTER_LOCATION,
  FILTER_WORK_CENTERS,
  FILTER_MANAGER,
  FILTER_RELATIONSHIPS,
]

export const WORKER_REQUEST_FILTERS = [
  FILTER_JOB,
  FILTER_LOCATION,
  FILTER_WORK_CENTERS,
  FILTER_SHIFT_PATTERN,
  FILTER_WORKER_TYPE,
  FILTER_WORKER_SUB_TYPE,
  FILTER_RELATIONSHIPS
]

// Time Off Requests page (Requests table + Calendar tab)
export const TIME_OFF_REQUEST_FILTERS = [
  FILTER_LOCATION,
  FILTER_WORK_CENTERS,
  FILTER_SHIFT_PATTERN,
  FILTER_RELATIONSHIPS,
]

// Flex Shift Requests page (status options come from /workers/requestStatuses).
// Location + Work Center (with cascade) + Worker Type / Sub Type.
export const FLEX_SHIFT_REQUEST_FILTERS = [
  FILTER_LOCATION,
  FILTER_WORK_CENTERS,
  FILTER_WORKER_TYPE,
  FILTER_WORKER_SUB_TYPE,
  FILTER_RELATIONSHIPS,
]

// Absence Report tabs (status options come from /workers/requestStatuses)
export const ABSENCE_REPORT_FILTERS = [
  FILTER_LOCATION,
  FILTER_WORK_CENTERS,
  FILTER_RELATIONSHIPS,
]